export default __webpack_public_path__ + "static/media/image-ph-study-report-n-w@2x.f31f0924.png";